module.exports = __webpack_public_path__ + "img/mobile-layout-05.eed2d382.jpg";